import { render } from "./spinner-component.vue?vue&type=template&id=4f8ed02d&scoped=true"
const script = {}

import "./spinner-component.vue?vue&type=style&index=0&id=4f8ed02d&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f8ed02d"]])

export default __exports__